export enum SaeAction {
  GET_POSITIONS = "GET_POSITIONS",
  POST_ROUTE = "POST_ROUTE"
}
